import BgOrderBump from './images/order-bump.svg';
import BgChatWhatsApp from './images/chat-whatsapp.svg';
import BgElements from './images/elements.svg';
import BgTheme from './images/theme.svg';
import BgExitPopup from './images/exit-popup.svg';
import BgToast from './images/toast.svg';

const getSunFeatures = () => {
  return [
    {
      icon: 'orderBumpOutline',
      title: 'Order Bump',
      backgroundImage: BgOrderBump,
      description: 'Crie ofertas adicionais dentro do checkout do seu produto para aumentar seu ticket-médio.',
      faqLink: 'https://ajuda.eduzz.com/hc/pt-br/articles/1260807006190-O-que-%C3%A9-e-como-cadastrar-o-Order-Bump-'
    },
    {
      icon: 'infoChatOutline',
      title: 'Chat e WhatsApp',
      backgroundImage: BgChatWhatsApp,
      description: 'Com o Chat sempre que houver dúvidas os clientes podem entrar em contato com você.',
      faqLink: 'https://ajuda.eduzz.com/hc/pt-br/articles/5051961310619-Como-adicionar-chat-ao-meu-checkout-'
    },
    {
      icon: 'online',
      title: 'Elements',
      backgroundImage: BgElements,
      description:
        'Praticidade e segurança! Integre nosso checkout diretamente na sua página de vendas e facilite suas vendas.',
      faqLink: 'https://ajuda.eduzz.com/hc/pt-br/articles/1260807004570-O-que-%C3%A9-o-Checkout-Elements-Sun-'
    },
    {
      icon: 'grid',
      title: 'Tema',
      backgroundImage: BgTheme,
      description:
        'Personalize o visual do seu Checkout de acordo com sua marca e produto, tendo assim mais diferencial no mercado.',
      faqLink:
        'https://ajuda.eduzz.com/hc/pt-br/articles/4411284304283-Como-personalizar-minha-p%C3%A1gina-de-Checkout-'
    },
    {
      icon: 'exit',
      title: 'Exit Pop up',
      backgroundImage: BgExitPopup,
      description: 'Ninguém sai! Mostre informações relevantes para manter seus clientes interessados na compra.',
      faqLink: 'https://ajuda.eduzz.com/hc/pt-br/articles/4403013603739-Como-configurar-o-desconto-de-sa%C3%ADda-'
    },
    {
      icon: 'notificationOutline',
      backgroundImage: BgToast,
      title: 'Toast',
      description: 'Tem gente de olho nesse produto! Adicione notificações e gatilhos para incentivar seus clientes.'
    }
  ];
};

export default getSunFeatures;
